module.exports = __webpack_public_path__ + "img/buddy_ears-03.edff8092.svg";